<template>
  <div class="container contenedorVista">
    <form-validator class="form">
      <wrap-container>
        <h1>Ingresá tus datos y empezá a referir</h1>
        <wrap-container class="referidos-container">
          <wrap-container>
            <number-input
              label="Legajo"
              hint="Ingresá tu Legajo"
              v-model="legajo"
              :required="true"
              maxlength="6"
            />
          </wrap-container>
          <wrap-container>
            <text-input label="Nombre" v-model="razonSocial" :required="true" />
          </wrap-container>
          <wrap-container>
            <sales-button
              class="button"
              label="Continuar"
              v-on:click="doGetLink"
            />
          </wrap-container>
        </wrap-container>
      </wrap-container>
    </form-validator>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SalesButton from "@/components/core/SalesButton";
import TextInput from "@/components/core/TextInput";
import FormValidator from "@/components/core/FormValidator";
import NumberInput from "@/components/core/NumberInput.vue";

export default {
  name: "ReferidosEmprendedores",
  components: {
    FormValidator,
    WrapContainer,
    SalesButton,
    TextInput,
    NumberInput
  },

  data() {
    return {
      razonSocial: "",
      legajo: "",
      showModal: false
    };
  },
  computed: {},
  methods: {
    doGetLink() {
      // this.showModal = true;
      window.open(
        "https://apps.bbva.com.ar/openmarket/contacto-empresas/productores-seguro/?origen=" +
          this.$route.params.origen +
          "&refe=" +
          encodeURIComponent(window.btoa(this.legajo)),
        "_blank"
      );
    }
  }
};
</script>

<style scoped>
.contenedorVista {
  margin: 0;
  background: url("../assets/img/1x/deco-meeting.svg");
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;
}
.referidos-container {
  max-width: 480px;
}
h1 {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  color: #121212;
  line-height: 1.33;
  font-size: 36px;
  font-weight: 500;
  margin-top: 0;
  letter-spacing: -0.4px;
  max-width: 600px;
}
textarea {
  display: block;
  width: 100%;
  border: 0;
  resize: none;
}

.contenedorVista {
  max-width: 1176px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 60px;
  padding-bottom: 60px;
  padding-left: 17px;
  padding-right: 17px;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  /* For mobile phones: */
  .contenedorVista {
    max-width: 960px;
  }
}

@media (max-width: 600px) {
  /* For mobile phones: */
  .contenedorVista {
    display: block;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

@media (max-width: 900px) {
  .contenedorVista {
    background: none;
  }
}
</style>
